export enum Roles {
	PRESENTER = 'presenter',
	REVIEWER = 'reviewer',
	INSTRUCTOR = 'instructor',
	OWNER = 'owner',
	ADMIN = 'admin',
}
